import { map, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import CollectionFilterOverview from 'containers/CollectionFilterOverviewContainer';
import CollectionFilterSelector from 'containers/CollectionFilterSelectorContainer';
import { COLLECTION_PAGE_FILTER_IDENTIFIERS } from 'utils/Filters';

import FilterPaneSection from './FilterPaneSection';

const CollectionFilterPane = ({ isLoading, filterIdentifiers }) =>
  isLoading || isEmpty(filterIdentifiers) ? null : (
    <div className="CollectionFilterPane">
      <FilterPaneSection className="CollectionFilterPane__overview">
        <CollectionFilterOverview />
      </FilterPaneSection>
      <div className="CollectionFilterPane__filter-selectors">
        {map(filterIdentifiers, filterIdentifier => {
          return (
            <FilterPaneSection
              className={`CollectionFilterPane__filter-selector CollectionFilterPane__filter-selector--${filterIdentifier}`}
              key={filterIdentifier}
            >
              <CollectionFilterSelector filterIdentifier={filterIdentifier} />
            </FilterPaneSection>
          );
        })}
      </div>
      <style jsx global>
        {`
          .CollectionFilterPane .FilterPaneSection:last-child {
            border-bottom: none;
          }
        `}
      </style>
    </div>
  );

CollectionFilterPane.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  filterIdentifiers: PropTypes.arrayOf(
    PropTypes.oneOf(Object.values(COLLECTION_PAGE_FILTER_IDENTIFIERS))
  ),
};

CollectionFilterPane.defaultProps = {
  filterIdentifiers: [],
};

export default CollectionFilterPane;
